import WeeklySlots from "pages/weekly-slots";
import BakesDates from "pages/bake-dates";

const routes = [
  // Customers
  {
    path: `/weekly-slots`,
    exact: true,
    auth: true,
    component: WeeklySlots,
  },
  { path: `/bake-dates`, exact: true, auth: true, component: BakesDates },
];

export default routes;
